import type { Tracker } from "@features/api/TrackerApi";

export function isTrackerUnreadByWatermark(
  tracker: Tracker,
  readAt: number,
): boolean {
  return Number(tracker.last_triggered ?? 0) > readAt;
}
